import {
	Component,
	Input,
	HostListener,
	ElementRef,
	OnInit,
	OnChanges,
	Output,
	EventEmitter,
	ViewChild,
	ViewContainerRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { AppServices } from "../../app.services";
import { ApplicationModel } from "app/core/models/application.model";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { CourseContextModelService } from "app/core/models/course-context-model.service";
import { AppConstants } from "app/core/vo/app-constants";

@Component({
	selector: "app-audio-custom-controls-directive",
	templateUrl: "./audio_custom_controller.directive.html",
	styleUrls: ["./audio_custom_controller.directive.css"],
})
export class AudioWithCustomControlsDirective implements OnInit, OnChanges {
	@Input() public path: string;
	@Input() public presMode: string;
	@Input() public audioOn: boolean;
	@Input() public pauseAudio: boolean;
	@Input() public enabledScrub: boolean;
	@Input() public language?: string;

	@Output() audioCompleted?: EventEmitter<any> = new EventEmitter<any>();
	@Output() audioStarted?: EventEmitter<any> = new EventEmitter<any>();
	@Output() timeUpdated?: EventEmitter<any> = new EventEmitter<any>();

	protected startEventFired: boolean = false;
	protected strTime: string = "00:00 / 00:00";

	@ViewChild("audioTag", { static: true }) _audioTag: ElementRef;
	@ViewChild("playpause", { static: true }) playpause: ElementRef;
	@ViewChild("mute") mute: ElementRef;
	@ViewChild("progress", { static: true }) progressBar: ElementRef;
	@ViewChild("progressBar", { static: true }) parentBar: ElementRef;
	@ViewChild("drag", { static: true }) drag: ElementRef;

	protected audio_el: any;
	protected playpause_el: any;
	protected mute_el: any;
	protected drag_el: any;
	protected parentBar_el: any;
	protected progressBar_el: any;
	public bPlaying: Boolean;
	public bAudioMute: Boolean;
	public bDisableAudioPanel: Boolean = false;
	public iOSDevice: Boolean = false;
	protected audioPauseSubscription: Subscription;
	protected showHideAudioPanelSubscription: Subscription;
	public device: string;
	private isPause: boolean = false;
	private isPlayBeforeDrag: Boolean = true;
	public showSpeedOptions: boolean = false;
	constructor(
		private elementRef: ElementRef,
		private appServices: AppServices,
		private courseContextModel: CourseContextModelService
	) {}
	ngOnInit() {
		this.iOSDevice = navigator.platform.indexOf("MacIntel") != -1;
		this.audioPauseSubscription = this.appServices.audioPauseEvent$.subscribe(
			(event) => this.audioPauseHandler()
		);
		this.showHideAudioPanelSubscription =
			this.appServices.disableAudioPanelEvent$.subscribe((event) =>
				this.disableAudioPanelHandler(event)
			);
		if (
			/iPhone|ipad/i.test(navigator.userAgent) ||
			(this.iOSDevice && window.innerWidth <= 1024)
		) {
			this.device = "ios";
		} else {
			this.device = "";
		}
	}
	ngOnChanges(changes) {
		console.log("changes", changes);
		if (
			changes.hasOwnProperty("pauseAudio") &&
			changes["pauseAudio"]["currentValue"] !== undefined
		) {
			if (changes["pauseAudio"]["currentValue"] === true) {
				this._audioTag.nativeElement.autoplay = false;
				this._audioTag.nativeElement.pause();
				this.bPlaying = false;
			} else {
				if (this.startEventFired && !this.isPause) {
					this._audioTag.nativeElement.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
					this.bPlaying = true;
				}
			}
		}
		if (changes.hasOwnProperty("path")) {
			if (this.progressBar_el) {
				this.progressBar_el.style.width = "0%";
			}
			if (this.drag_el) {
				this.drag_el.style.left = "0%";
			}
			this.strTime = "00:00 / 00:00";
		}
		if (this.pauseAudio) {
			this._audioTag.nativeElement.autoplay = false;
			this._audioTag.nativeElement.pause();
			this.bPlaying = false;
		}
		if (
			changes.hasOwnProperty("language") &&
			changes["language"]["currentValue"] !== undefined
		) {
			console.log("this.language changed", this.language);
			if (this.audio_el && this.language) {
				this.configPlayerSpeed();
			}
		}
	}

	ngAfterViewInit() {
		this.startEventFired = false;
		this.bPlaying = false;
		this.bAudioMute = false;
		const _owner = this;
		this.audio_el = this._audioTag.nativeElement;
		this.playpause_el = this.playpause.nativeElement;
		this.mute_el = this.mute ? this.mute.nativeElement : null;
		this.progressBar_el = this.progressBar.nativeElement;
		this.parentBar_el = this.parentBar.nativeElement;
		this.drag_el = this.drag.nativeElement;
		this.audio_el.muted = ApplicationModel.instance.muteAudioVideo;
		this.bAudioMute = ApplicationModel.instance.muteAudioVideo;
		if (this.drag_el) {
			this.drag_el.addEventListener(
				"mousedown",
				this.onScrubHandleClick.bind(this),
				false
			);
			this.drag_el.addEventListener(
				"touchstart",
				this.onScrubHandleClick.bind(this),
				false
			);
			this.drag_el.addEventListener(
				"keydown",
				this.sliderProgressKeyboard.bind(this),
				false
			);
		}
		if (this.audio_el) {
			this.audio_el.removeAttribute("controls");
			this.audio_el.addEventListener(
				"play",
				function () {
					this.bPlaying = true;
				},
				false
			);
			this.audio_el.addEventListener(
				"pause",
				function () {
					this.bPlaying = false;
				},
				false
			);
			this.configPlayerSpeed();
		}
	}
	ontimeupdate(evt) {
		var value = 0;
		if (this.audio_el.currentTime > 0 && !this.startEventFired) {
			this.startEventFired = true;
			this.bDisableAudioPanel = false;
			if (!this.enabledScrub) {
				this.bPlaying = true;
			}
			this.audioStarted.emit(evt);
		}
		if (
			this.audio_el &&
			this.audio_el.currentTime >= 0 &&
			this.audio_el.duration > 0
		) {
			this.strTime =
				this.timeFormat(this.audio_el.currentTime) +
				" / " +
				this.timeFormat(this.audio_el.duration);
			value = Math.ceil(
				(100 / this.audio_el.duration) * this.audio_el.currentTime
			);
			if (value > 100) {
				value = 100;
				this.startEventFired = false;
				this.bPlaying = false;
			}
		}
		if (this.progressBar_el) {
			this.progressBar_el.style.width = value + "%";
			this.progressBar_el.ariaValueNow = Math.floor(this.audio_el.currentTime);
			this.progressBar_el.ariaValueMax = Math.floor(this.audio_el.duration);
			this.progressBar_el.ariaValueText =
				this.timeFormatAriaText(this.audio_el.currentTime) +
				" of " +
				this.timeFormatAriaText(this.audio_el.duration);
		}
		if (this.drag_el) {
			this.drag_el.style.left = `${value}%`;
			this.drag_el.ariaValueNow = Math.floor(this.audio_el.currentTime);
			this.drag_el.ariaValueMax = Math.floor(this.audio_el.duration);
			this.drag_el.ariaValueText =
				this.timeFormatAriaText(this.audio_el.currentTime) +
				" of " +
				this.timeFormatAriaText(this.audio_el.duration);
		}
		if (this.audio_el.ended) {
			this.bPlaying = false;
			this.startEventFired = false;
		}
		this.timeUpdated.emit(this._audioTag.nativeElement);
	}
	onEnded(evt) {
		this.startEventFired = false;
		this.audioCompleted.emit({ url: this.path });
	}
	public playAudio() {
		//this.configPlayerSpeed();
		this.bPlaying = true;
		this._audioTag.nativeElement.autoplay = true;
		this._audioTag.nativeElement.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
		this.audio_el.muted = ApplicationModel.instance.muteAudioVideo;
		this.bAudioMute = ApplicationModel.instance.muteAudioVideo;
		// if(ApplicationModel.instance.unmuteAudioOnRubricLoad)
		// {
		//   this.unmuteDefault();
		// }
	}
	public audioPauseHandler() {
		this.bPlaying = false;
		this._audioTag.nativeElement.autoplay = true;
		this._audioTag.nativeElement.pause();
	}

	public disableAudioPanelHandler(bVal) {
		this.bDisableAudioPanel = bVal;
	}

	public stopAudio() {
		this.bPlaying = false;
		this._audioTag.nativeElement.pause();
		if (this._audioTag.nativeElement.currentTime > 0)
			this._audioTag.nativeElement.currentTime = 0;
	}
	public togglePlayPause() {
		if (this.audio_el.paused || this.audio_el.ended) {
			this.bPlaying = true;
			this.isPause = false;
			this.audio_el.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
		} else {
			this.bPlaying = false;
			this.isPause = true;
			this.audio_el.pause();
		}
	}
	public progressBarClickHandler(event) {
		if (this.enabledScrub) {
			let progressBarCoOrds: any = event.currentTarget.getBoundingClientRect();
			let left = event.pageX - progressBarCoOrds.left;
			let totalWidth = progressBarCoOrds.width;
			let percentage = left / totalWidth;
			let vidTime = this.audio_el.duration * percentage;
			if (this.audio_el.paused || this.audio_el.ended) {
				this.audio_el.pause();
				this.bPlaying = false;
			}
			this.audio_el.currentTime = vidTime;
		}
	}

	public onScrubHandleClick(e) {
		if (this.enabledScrub) {
			if (e.cancelable) {
				e.preventDefault();
			}
			this.isPlayBeforeDrag = this.bPlaying;
			let progressBarCoOrds: any = this.parentBar_el.getBoundingClientRect();
			let totalWidth = progressBarCoOrds.width;
			const closeElementDrag = () => {
				document.onmouseup = document.ontouchend = null;
				document.onmousemove = document.ontouchmove = null;
				if (this.isPlayBeforeDrag) {
					this.audio_el.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
					this.bPlaying = true;
				} else {
					this.audio_el.pause();
					this.bPlaying = false;
				}
			};
			document.onmouseup = closeElementDrag;
			document.ontouchend = closeElementDrag;
			const elementDrag = (evnt) => {
				evnt.preventDefault();
				let clientX =
					evnt.type === "touchmove" ? evnt.touches[0].clientX : evnt.clientX;
				let left = clientX - progressBarCoOrds.left;
				left = left < 0 ? 0 : left > totalWidth ? totalWidth : left;
				let percentage = left / totalWidth;
				let vidTime = this.audio_el.duration * percentage;
				this.audio_el.currentTime = vidTime;
				this.audio_el.pause();
				this.bPlaying = false;
			};
			document.onmousemove = elementDrag;
			document.ontouchmove = elementDrag;
		}
	}
	public sliderProgressKeyboard(e) {
		const removeKeyEvent = () => {
			document.onkeydown = null;
		};
		const elementKeyboardDrag = (e) => {
			if (
				e.keyCode === 37 &&
				this.audio_el.currentTime > 0 &&
				this.enabledScrub
			) {
				let vidTime = this.audio_el.currentTime - 10;
				this.audio_el.currentTime = vidTime;
			}
			if (
				e.keyCode === 39 &&
				this.audio_el.currentTime < this.audio_el.duration &&
				this.enabledScrub
			) {
				let vidTime = this.audio_el.currentTime + 10;
				this.audio_el.currentTime = vidTime;
			}
				document.onkeydown = removeKeyEvent;
		};
		document.onkeydown = elementKeyboardDrag;
	}
	public toggleMute() {
		this.audio_el.muted = !this.audio_el.muted;
		ApplicationModel.instance.muteAudioVideo = this.audio_el.muted;
		this.bAudioMute = !this.bAudioMute;
	}
	protected timeFormat(seconds) {
		var m: any =
			Math.floor(seconds / 60) < 10
				? "0" + Math.floor(seconds / 60)
				: Math.floor(seconds / 60);
		var s: any =
			Math.floor(seconds - m * 60) < 10
				? "0" + Math.floor(seconds - m * 60)
				: Math.floor(seconds - m * 60);
		return m + ":" + s;
	}
	
	protected timeFormatAriaText(seconds) {
		if (seconds) {
			var m: any = Math.floor(seconds / 60);
			var s: any = Math.floor(seconds - m * 60);
			return m + " Minutes " + s + " Seconds";
		} else {
			return "0 Minutes 0 Seconds";
		}
	}
	private configPlayerSpeed() {
		this.showSpeedOptions =
			this.courseContextModel.currentLanguage == AppConstants.US_ENGLISH
				? false
				: true;
		if (this.showSpeedOptions) {
			if (ApplicationModel.instance.playerSpeed) {
				this.audio_el.playbackRate = ApplicationModel.instance.playerSpeed;
			}
		} else {
			this.audio_el.defaultPlaybackRate = 1;
			this.audio_el.playbackRate = 1;
		}
	}
	public onSpeedSelected(value) {
		this.audio_el.playbackRate = value;
		ApplicationModel.instance.playerSpeed = value;
	}
	public get speed() {
		return ApplicationModel.instance.playerSpeed
			? ApplicationModel.instance.playerSpeed
			: 1;
	}
	// public unmuteDefault() {
	//   this.audio_el.muted = false;
	//   this.bAudioMute =  false;
	//   ApplicationModel.instance.unmuteAudioOnRubricLoad=false;
	// }
}
